import { gql } from '@apollo/client';

const QUERY_PRODUCTS_FOR_DROPDOWN = gql`
  query ProductsForDropdown($publisher: Int!) {
    products(publisher: $publisher) {
      id
      productWork {
        id
        title
      }
      isbn
      format {
        description
      }
      frozen
    }
  }
`;

export default QUERY_PRODUCTS_FOR_DROPDOWN;
